/*
 * @Author: yeqing
 * @Date: 2021-11-24 09:48:37
 * @LastEditTime: 2022-05-25 10:27:54
 * @LastEditors: yeqing
 * @Description: 专精特新接口
 * @FilePath: \fe-frame-page\src\api\enterpriseSpecial.js
 */

import request from '@/utils/request'

// 中小企业测评
export function smallAndMediumEnterpriseEva(data) {
  return request({
    url: '/evaTool/smallAndMediumEnterpriseEva',
    method: 'post',
    data,
  })
}


export function smallAndMediumEnterpriseEvaV2(data) {
  return request({
    url: '/evaTool/smallAndMediumEnterpriseEvaV2',
    method: 'post',
    data,
  })
}
// 小巨人企业测评
export function littleGiantEva(data) {
  return request({
    url: '/evaTool/littleGiantEva',
    method: 'post',
    data,
  })
}

// 中小pdf上传
export function pdfUploadApi(data) {
  return request({
    url: '/evaTool/reportUpload',
    method: 'post',
    data,
  })
}

// 中小pdf下载
export function pdfDownloadApi(id, type) {
  return request({
    url: `/evaTool/downloadEvaluationReport/${id}`,
    method: 'get',
    responseType:type
  })
}


// 中小企业测评次数统计
export function evaStatisticsApi(data) {
  return request({
    url: `/evaTool/evaStatistics`,
    method: 'post',
    data
  })
}

// 专精特精 次数统计
export function clickStatistics (clickType) {
  return request({
    url: '/clickStatistics/save',
    method: 'post',
    data: { clickType }
  })
}

// 专精特精测评记录
export function getRecords (data) {
  return request({
    url: '/evaTool/report/pageV2',
    method: 'post',
    data
  })
}

// 近7天查询报告企业名称
export function getReportName (data) {
  return request({
    url: '/evaTool/reportName',
    method: 'post',
    data
  })
}

// 删除测评记录
export function reportDelete (params) {
  return request({
    url: '/evaTool/reportDelete',
    method: 'get',
    params
  })
}